export default {
    spec_fuel_petrol: 'gas',
    spec_fuel_petrol_diesel: 'gas/diesel',
    excess: 'Excess liability',
    security: 'Security deposit',
    fuel_policy: 'Fuel policy',
    like_for_like: 'Like for Like',
    full_to_full: 'Full to Full',
    mileage: 'Mileage: {mileage} miles per rental',
    unlimited_mileage: 'Unlimited mileage',
    non_refundable: 'Non refundable',
    free_cancellation_until: 'Free cancellation up until {date}',
    cancellation_with_terms: 'Cancellation {0} in line with ',
    t_c_text: 'T&Cs',
    two_free_extras: 'Two free extras on collection',
    glass_tyres_covered: 'Glass and tyres covered',
};
